export default "__VITE_ASSET__CDcHtqZa__"